import { render, staticRenderFns } from "./editOss.vue?vue&type=template&id=9cf96fe6&scoped=true&"
import script from "./editOss.vue?vue&type=script&lang=js&"
export * from "./editOss.vue?vue&type=script&lang=js&"
import style0 from "./editOss.vue?vue&type=style&index=0&id=9cf96fe6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf96fe6",
  null
  
)

export default component.exports